module.exports = __webpack_public_path__ + "media/stylesheets/images/media/belcy_bg-f8d08d153749119ed7188be53c9eaab8.jpg";